import React from 'react'

// css
import 'assets/style/components/image-slider.scss'

// elements
import { Image, IconButton } from 'components'

function Component({ className, data = [], addButton = false, addButtonClick }) {
  return (
    <div className={'image-container ' + className}>
      <section className="image-slider">
        <div className="image-wrap">
          {data.map((item, index) => (
            <Image
              src={item.src}
              cTTL={item.cTTL || false}
              alt={item?.alt}
              className={'item ' + item?.className}
              key={`image_${index}`}
              watermarkYn={item?.watermarkYn || false}
            />
            // <img src={item.src} alt={item?.alt} className={'item ' + item?.className} key={`image_${index}`} />
          ))}
          {[true, 'true'].includes(addButton) && (
            <div
              className="img-add"
              onClick={addButtonClick}
              style={{ width: data.length > 0 ? '120px' : '100%', height: '210px' }}
            >
              <IconButton type="round-cross" onClick={addButtonClick} size={'48'} />
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default Component
